import React from "react";

export default function Footer(props) {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <section className="contact-area" id="contact">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="contact-content text-center">

                <a href="/" aria-label="Arjun Singh Home" className="d-block mb-3">
                  {props.mode === "light" ? (
                    <img
                      src={props.logoSrcBlack}
                      alt="Arjun Web"
                      className="img-fluid logo"
                    />
                  ) : (
                    <img
                      src={props.logoSrcWhite}
                      alt="Arjun Web"
                      className="img-fluid logo"
                    />
                  )}
                </a>

                <div className="availability-badge">
                  <span className="status-dot"></span>
                  Available for Opportunities
                </div>

                <h3 className="pt-3">Let's Build Something Great Together</h3>

                <p>
                  I'm Arjun Singh, a Senior Frontend Developer specializing in
                  Next.js, React.js, TypeScript, Tailwind CSS, and modern web
                  technologies. I build responsive, scalable, high-performance,
                  and user-focused digital experiences.
                </p>

                <h6>
                  <i className="fas fa-map-marker-alt me-2"></i>
                  New Delhi, India
                </h6>

                <h6 className="py-3">
                  <a href="tel:+919990031433" className={` text-${
                            props.mode === "light" ? "dark" : "light"
                          }`}>
                    <i className="fas fa-phone-alt me-2"></i>
                    +91 9990031433
                  </a>

                  <span>|</span>

                  <a href="mailto:kohliarjun823@gmail.com" className={` text-${
                            props.mode === "light" ? "dark" : "light"
                          }`}>
                    <i className="fas fa-envelope me-2"></i>
                    kohliarjun823@gmail.com
                  </a>
                </h6>

                <div className="footer-actions">
                  <a
                    href="/resume.pdf"
                    download
                    className="btn btn-primary2"
                  >
                    <i className="fas fa-download me-2"></i>
                    Download Resume
                  </a>

                  <a
                    href="/contact"
                    className={`btn btn-${props.mode === 'light' ? 'outline-dark' : 'outline-light'} ms-2 text-${
                            props.mode === "light" ? "dark" : "light"
                          }`}
                  >
                    Let's Connect
                  </a>
                </div>

                <div className="contact-social">
                  <ul>
                    <li>
                      <a
                        className="hover-target"
                        href="https://github.com/arjun-kohli95"
                        target="_blank"
                        rel="noreferrer"
                        aria-label="GitHub"
                      >
                        <i className="fab fa-github"></i>
                      </a>
                    </li>

                    <li>
                      <a
                        className="hover-target"
                        href="https://www.linkedin.com/in/arjun-singh-200797362"
                        target="_blank"
                        rel="noreferrer"
                        aria-label="LinkedIn"
                      >
                        <i className="fab fa-linkedin-in"></i>
                      </a>
                    </li>

                    <li>
                      <a
                        className="hover-target"
                        href="mailto:kohliarjun823@gmail.com"
                        aria-label="Email"
                      >
                        <i className="fas fa-envelope"></i>
                      </a>
                    </li>
                  </ul>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div className="bubbles">
          {[...Array(10)].map((_, index) => (
            <div className="bubble" key={index}></div>
          ))}
        </div>
      </section>

      <footer>
        <p>
          Copyright &copy; {currentYear}{" "}
          <span className="brandText">
            <b>Arjun Singh</b>
          </span>
          . All Rights Reserved.
        </p>
      </footer>
    </>
  );
}